import { HTMLAttributes } from 'react';
import styled from 'styled-components';

export const Button = styled.button<{ $mb?: string | number } & HTMLAttributes<HTMLButtonElement>>`
  margin: 0 auto ${({ $mb = 0 }) => $mb}px;
  display: block;
  text-transform: uppercase;
  background: transparent;
  padding: 4px;
  cursor: pointer;
`;
